import { render, staticRenderFns } from "./topNewbar2.vue?vue&type=template&id=0ee578fa&scoped=true"
import script from "./topNewbar2.vue?vue&type=script&lang=js"
export * from "./topNewbar2.vue?vue&type=script&lang=js"
import style0 from "./topNewbar2.vue?vue&type=style&index=0&id=0ee578fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee578fa",
  null
  
)

export default component.exports